export default "__VITE_ASSET__9Zey5mIT__"